<p class="text-muted small mt-2">
    The 500 descriptions with the most lines. Median price uses only the most common unit for that description.
</p>
<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="itemGrid"></action-toolbar-count>
                    <button type="button" class="btn btn-sm btn-primary" [disabled]="!itemGrid.selectedItem" (click)="openPriceHistory()">
                        Price history
                    </button>
                    <grid-export [grid]="gridItems" [name]="'Purchased Material Items'"></grid-export>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <grid-column-group [grid]="itemGrid"></grid-column-group>
                <wj-flex-grid
                    id="gridItems"
                    #gridItems
                    appAutoSize
                    [padding]="73"
                    [isReadOnly]="true"
                    (initialized)="itemGrid.initialize(gridItems)"
                    (destroy)="itemGrid.destroy()"
                    [itemsSource]="itemGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="420" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Part number'" [binding]="'partNumber'" [width]="150" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Vendors'" [binding]="'vendorCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Quantity'" [binding]="'quantity'" [width]="110" [format]="'n2'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Unit'" [binding]="'unit'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Median unit price'" [binding]="'medianUnitPrice'" [width]="150" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'First invoice'" [binding]="'firstDate'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Last invoice'" [binding]="'lastDate'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="gridItems"></grid-selection-calculation>
            </div>
        </div>
    </div>
</div>
